import React from 'react';
import {connect} from 'react-redux';
import numeral from 'numeral';
import moment from 'moment';
import map from 'lodash/map';
import Chart from 'chart.js';

import selectEntities from '../../../../../selectors/entities';
import {
  fetchStatsIfNeeded,
  refreshStats,
} from '../../../../../actions/app/monitoring/statistics/registrations';

import './RegistrationsWidget.css';
import Loader from '../../../../../components/Loader';
import DateRangePickerWrapper from '../../../../../components/DatePicker/DateRangePickerWrapper';

import earthFlag from '../../../../../assets/img/other/flag-earth.svg';

let chart;

class RegistrationsWidget extends React.Component {
  constructor(props) {
    super(props);

    // We set the date to yesterday and we subtract 30 days
    const today = new Date();
    const end = moment(today.setDate(today.getDate())).format('YYYY-MM-DD');
    const start = moment(today.setDate(today.getDate() - 30)).format(
      'YYYY-MM-DD',
    );

    this.state = {end, start};
  }

  fetchStats() {
    const {end, start} = this.state;
    this.props.dispatch(fetchStatsIfNeeded({endDate: end, startDate: start}));
  }

  refreshStats() {
    const {end, start} = this.state;
    this.props.dispatch(refreshStats({endDate: end, startDate: start}));
  }

  componentDidMount() {
    // this.fetchStats();

    const ctx = document.getElementById('newMembersChart');
    if (ctx)
      chart = new Chart(ctx, {
        type: 'bar',
        data: {datasets: []},
        options: {
          scales: {
            xAxes: [
              {
                id: 'date',
                type: 'time',
                stacked: true,
              },
            ],
            yAxes: [
              {
                id: 'members',
                type: 'linear',
                stacked: true,
              },
            ],
          },
        },
      });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.widget.ids !== this.props.widget.ids) {
      const {entities} = nextProps.statistics;

      const datasets = [
        {
          label: 'FR',
          backgroundColor: '#45c945',
          xAxisID: 'date',
          yAxisID: 'members',
          data: [],
        },
        {
          label: 'GB',
          backgroundColor: '#0073b7',
          xAxisID: 'date',
          yAxisID: 'members',
          data: [],
        },
        {
          label: 'ES',
          backgroundColor: '#dd4b39',
          xAxisID: 'date',
          yAxisID: 'members',
          data: [],
        },
        {
          label: 'Other',
          backgroundColor: '#454545',
          xAxisID: 'date',
          yAxisID: 'members',
          data: [],
        },
      ];

      map(entities, ({mpg, date}) => {
        datasets[0].data.push({
          x: moment(date).format('LL'),
          y: parseInt(mpg.FR, 10),
        });
        datasets[1].data.push({
          x: moment(date).format('LL'),
          y: parseInt(mpg.GB, 10),
        });
        datasets[2].data.push({
          x: moment(date).format('LL'),
          y: parseInt(mpg.ES, 10),
        });
        datasets[3].data.push({
          x: moment(date).format('LL'),
          y: parseInt(mpg.OTHER, 10),
        });
      });

      chart.data.datasets = datasets;
      chart.update();
    }
  }

  render() {
    const {end, start} = this.state;
    const {info} = this.props.widget;
    let {entities, total} = this.props.statistics;

    let sum = {ALL: 0, FR: 0, GB: 0, ES: 0, OTHER: 0};
    // eslint-disable-next-line
    const increasingCumulativeAMount = entities.map(({mpg}) => {
      sum.ALL += mpg.ALL || 0;
      sum.FR += mpg.FR || 0;
      sum.GB += mpg.GB || 0;
      sum.ES += mpg.ES || 0;
      sum.OTHER += mpg.OTHER || 0;

      return {data: mpg, amount: sum};
    });

    return (
      <div id="registrations-widget" className="row">
        <div className="col-md-12">
          <div className="box">
            <div className="box-header with-border">
              <h3 className="box-title pull-left">
                <i className="fa fa-user-plus" /> Registrations / New members
              </h3>
              <div className="box-tools pull-right">
                <button
                  type="button"
                  className="btn btn-box-tool"
                  onClick={() => this.refreshStats()}>
                  <i className="fa fa-refresh" />
                </button>
                <button
                  type="button"
                  className="btn btn-box-tool"
                  data-widget="collapse">
                  <i className="fa fa-minus" />
                </button>
              </div>
            </div>
            <div className="box-body">
              <div className="text-center margin-bottom">
                New members from
                <div className="inline data-range-picker">
                  <DateRangePickerWrapper
                    initialStartDate={moment(start)}
                    initialEndDate={moment(end)}
                    minimumNights={0}
                    onDatesChange={({startDate, endDate}) => {
                      this.setState({
                        start: moment(startDate).format('YYYY-MM-DD'),
                        end: moment(endDate).format('YYYY-MM-DD'),
                      });
                    }}
                  />
                  <button
                    className="btn btn-default"
                    onClick={() => this.refreshStats()}>
                    <i className="fa fa-refresh" />
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="chart">
                    <canvas id="newMembersChart" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="table-responsive table-fixed-height">
                    <table className="table table-bordered no-margin">
                      <thead>
                        <tr>
                          <th>Day</th>
                          <th className="text-center">
                            <i className="flag-icon flag-icon-fr" />
                          </th>
                          <th className="text-center">
                            <i className="flag-icon flag-icon-gb" />
                          </th>
                          <th className="text-center">
                            <i className="flag-icon flag-icon-es" />
                          </th>
                          <th className="text-center">
                            <img
                              src={earthFlag}
                              alt="Drapeau de la terre"
                              className="flag-img"
                            />
                          </th>
                          <th className="text-center">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {entities.map(({mpg, date}, key) => (
                          <tr key={key} className="text-center">
                            <td className="text-left">
                              {moment(date).format('LL')}
                            </td>
                            <td>{mpg.FR}</td>
                            <td>{mpg.GB}</td>
                            <td>{mpg.ES}</td>
                            <td>{mpg.OTHER}</td>
                            <td>{mpg.ALL}</td>
                          </tr>
                        ))}
                        {entities.length > 0 && (
                          <tr key="all" className="text-center">
                            <td className="text-left">
                              Sum from {moment(start).format('LL')} to &nbsp;
                              {moment(end).format('LL')}
                            </td>
                            <td>{sum.FR}</td>
                            <td>{sum.GB}</td>
                            <td>{sum.ES}</td>
                            <td>{sum.OTHER}</td>
                            <td>{sum.ALL}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            {total && (
              <div className="box-footer">
                <div className="row">
                  <div className="col-xs-12 col-md-4">
                    <div className="description-block border-right">
                      <h5 className="description-header">
                        {numeral(total.mpg.FR, 10).format('0,0')}
                      </h5>
                      <span className="description-text text-green">FR</span>
                    </div>
                  </div>
                  <div className="col-xs-6 col-md-4">
                    <div className="description-block border-right">
                      <h5 className="description-header">
                        {numeral(total.mpg.GB, 10).format('0,0')}
                      </h5>
                      <span className="description-text text-blue">GB</span>
                    </div>
                  </div>
                  <div className="col-xs-6 col-md-4">
                    <div className="description-block">
                      <h5 className="description-header">
                        {numeral(total.mpg.ES, 10).format('0,0')}
                      </h5>
                      <span className="description-text text-red">ES</span>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-6">
                    <div className="description-block border-right">
                      <h5 className="description-header">
                        {numeral(total.mpg.OTHER, 10).format('0,0')}
                      </h5>
                      <span className="description-text">Other</span>
                    </div>
                  </div>
                  <div className="col-xs-6">
                    <div className="description-block border-right">
                      <h5 className="description-header">
                        {numeral(total.mpg.ALL, 10).format('0,0')}
                      </h5>
                      <span className="description-text">All</span>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {info.isFetching && <Loader />}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  state => {
    const {statistics} = state.entities;
    const {registrations} = state.app.statistics;

    return {
      widget: registrations,
      statistics: {
        entities: selectEntities(statistics, registrations.ids),
        total: registrations.total,
      },
    };
  },
  dispatch => ({dispatch}),
)(RegistrationsWidget);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Widgets/Registrations/index.js